import React, { useEffect, useState } from "react";
import { GroupManagement } from "../screens/GroupManagement";
import { GroupSelection } from "../screens/GroupSelection";
import { useGetCurrentGroup } from "../api/groups/useGetCurrentGroup";
import { MainLayout } from "./MainLayout";
import { useApp } from "./AppContext";

/**
 * GroupRouter component that decides whether to show GroupManagement or GroupSelection
 * based on whether the user has a group or not
 */
export function GroupRouter() {
	const { navigateDirectly } = useApp();
	const { group, loading, error } = useGetCurrentGroup();
	const [shouldShowManagement, setShouldShowManagement] = useState<
		boolean | null
	>(null);

	useEffect(() => {
		// Only update the state once loading is complete
		if (!loading) {
			setShouldShowManagement(!!group);
		}
	}, [group, loading]);

	// Show loading state while fetching group data
	if (loading || shouldShowManagement === null) {
		return (
			<MainLayout showBack={true} onBack={() => navigateDirectly("dashboard")}>
				<div className="text-center py-8">
					<p className="text-[var(--ucm-text-medium)]">
						Loading group information...
					</p>
				</div>
			</MainLayout>
		);
	}

	// Show GroupManagement if user has a group, otherwise show GroupSelection
	return shouldShowManagement ? <GroupManagement /> : <GroupSelection />;
}
